import { useEffect, useRef } from 'react';

import keyboardManagerLib from 'Lib/keyboard/manager';

const useKeyboardManager = ({ isMobile }: { isMobile: boolean }) => {
  const keyboardManager = useRef<typeof keyboardManagerLib | null>(null);

  useEffect(() => {
    let managerInstance = keyboardManager.current;
    if (!managerInstance && !isMobile) {
      import('Lib/keyboard/manager' /* webpackChunkName: "pc-KeyboardManager" */).then(
        ({ default: lib }) => {
          lib.init();
          managerInstance = lib;
          keyboardManager.current = managerInstance;
        }
      );
    }

    return () => {
      managerInstance?.destroy();
      keyboardManager.current = null;
    };
  }, [isMobile]);
};

export default useKeyboardManager;
